export default __webpack_public_path__ + "madfit-devices_mobile.25196451.png";